/**
 * Общие правила двуязычных пар: если заполнена одна сторона пары, должна быть
 * заполнена и вторая. Используется формами карточек и stage-валидацией SoH.
 */

/**
 * Проверяет, есть ли пользовательское значение в строке, relation, multiselect или дате.
 *
 * @param {*} value Проверяемое значение формы.
 * @returns {boolean} true, если поле считается заполненным.
 */
export function hasBilingualValue(value) {
  if (value === null || value === undefined) {
    return false
  }
  if (typeof value === 'string') {
    return value.trim().length > 0
  }
  if (Array.isArray(value)) {
    return value.length > 0
  }
  if (value instanceof Date) {
    return !Number.isNaN(value.getTime())
  }
  if (typeof value === 'object') {
    if (Object.prototype.hasOwnProperty.call(value, 'id')) {
      return value.id !== null && value.id !== undefined && value.id !== ''
    }
    return Object.values(value).some(item => hasBilingualValue(item))
  }
  return Boolean(value)
}

/**
 * Возвращает поля пары, которые нужно заполнить для консистентного сохранения.
 *
 * @param {object} source Объект модели или вложенной карточки.
 * @param {Array<string>} fields Два имени полей одной двуязычной пары.
 * @returns {Array<string>} незаполненные поля пары.
 */
export function getBilingualPairMissingFields(source, fields) {
  const pairFields = Array.isArray(fields) ? fields.slice(0, 2) : []
  if (pairFields.length !== 2) {
    return []
  }

  const filled = pairFields.map(field => hasBilingualValue(source?.[field]))
  if (!filled.some(Boolean) || filled.every(Boolean)) {
    return []
  }

  return pairFields.filter((_field, index) => !filled[index])
}

/**
 * Создаёт правило для общего компонента Form.
 *
 * @param {string} first Первое поле пары.
 * @param {string} second Второе поле пары.
 * @param {string} message Сообщение для незаполненной стороны пары.
 * @returns {object} правило Form.
 */
export function bilingualPairRule(first, second, message) {
  return {
    type: 'bilingualPair',
    fields: [first, second],
    message,
  }
}
